// extracted by mini-css-extract-plugin
export default {"PointerBox":"NumberField-module__PointerBox--BLSzg"};